import * as React from "react";
import {
  UitkCard,
  UitkPlaceholderCard,
  UitkCardImageLayout,
  UitkCardMedia,
  UitkCardContent,
  UitkCardTextSegment,
} from "uitk-react-cards";
import { UitkTextSkeleton } from "uitk-react-skeleton";
import { Viewport, ViewSmall, ViewMedium, ViewLarge } from "bernie-view";

export const TripAttachLoadingView = () => (
  <div className="TripAttachQualification uitk-cell all-cell-1-1 all-t-margin-twelve all-b-margin-six">
    <div className="all-b-margin-two" />
    <div className="uitk-grid all-x-gutter-three all-y-gutter-three">
      <div className="uitk-cell s-cell-1-1 all-cell-1-2 uitk-grid">
        <div className="uitk-flex uitk-flex-grow-1">
          <UitkCard>
            <UitkCardMedia>
              <Viewport>
                <ViewSmall>
                  <UitkPlaceholderCard className="ratio-3-1" />
                </ViewSmall>
                <ViewMedium>
                  <UitkPlaceholderCard />
                </ViewMedium>
                <ViewLarge>
                  <UitkPlaceholderCard className="ratio-3-1" />
                </ViewLarge>
              </Viewport>
            </UitkCardMedia>
          </UitkCard>
        </div>
      </div>
      <div className="uitk-cell s-cell-1-1 all-cell-1-2 uitk-grid">
        <div className="uitk-flex uitk-flex-grow-1">
          <UitkCard imageLayout={UitkCardImageLayout.LEFT_FULLBLEED}>
            <UitkCardMedia>
              <UitkPlaceholderCard className="uitk-flat-border-right" />
            </UitkCardMedia>
            <UitkCardContent>
              <UitkCardTextSegment className="uitk-grid all-x-gutter-three all-y-gutter-three">
                <div className="uitk-cell all-cell-2-3">
                  <UitkTextSkeleton />
                </div>
                <div className="uitk-cell all-cell-1-3" />
                <div className="uitk-cell all-cell-1-3 all-b-margin-twelve">
                  <UitkTextSkeleton />
                </div>
                <div className="uitk-cell all-cell-2-3" />
              </UitkCardTextSegment>
            </UitkCardContent>
          </UitkCard>
        </div>
      </div>
    </div>
  </div>
);

export default TripAttachLoadingView;
